/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { animated, Transition } from 'react-spring/renderprops.cjs'
import { IMediaCard } from '../types'
import CardItem from './featuredMediaCardItem'
import { IFeaturedMediaCardsSFC } from './types'

const removeWithKey = (key: string, props: IFeaturedMediaCardsSFC) => () =>
  props.remove(key)
const cardKeyGetter = (item: IMediaCard) => item.key
const toggleRequiredWithKey = (
  key: string,
  props: IFeaturedMediaCardsSFC
) => () => props.toggleRequired(key)

export const _cardItemRenderer = (props: IFeaturedMediaCardsSFC) => (
  card: IMediaCard
  // eslint-disable-next-line react/display-name
) => (style) => (
  <animated.div style={{ ...style, height: 'auto' }}>
    <CardItem
      key={card.key}
      card={card}
      remove={removeWithKey(card.key, props)}
      toggleRequired={toggleRequiredWithKey(card.key, props)}
    />
  </animated.div>
)

const initialStyles = {
  maxHeight: 210,
  opacity: 1,
  transform: 'scale(1)',
}
const minifiedStyles = {
  maxHeight: 0,
  opacity: 0,
  transform: 'scale(0)',
}

const FeaturedMediaCardsSFC = (props: IFeaturedMediaCardsSFC): JSX.Element => (
  <Transition
    native={true}
    initial={initialStyles}
    items={props.cards}
    keys={cardKeyGetter}
    from={minifiedStyles}
    enter={initialStyles}
    leave={minifiedStyles}
  >
    {_cardItemRenderer(props)}
  </Transition>
)

export default FeaturedMediaCardsSFC
